import { config } from "../../../../config/config";
import { getNodeAuthHeaders } from "../../../../features/Affiliates/api/createAffiliateApi";

const getNodeApiBaseUrl = () =>
  (
    process.env.REACT_APP_NODE_API_URL ||
    config.node_api_url ||
    (window.location.hostname === "localhost" ? "http://localhost:4000" : "")
  ).replace(/\/+$/, "");

export const changePasswordViaNodeApi = async (oldPassword: string, newPassword: string) => {
  const nodeApiBaseUrl = getNodeApiBaseUrl();
  if (!nodeApiBaseUrl) {
    throw new Error("REACT_APP_NODE_API_URL is not configured");
  }

  const response = await fetch(`${nodeApiBaseUrl}/api/changePassword`, {
    method: "POST",
    headers: getNodeAuthHeaders(),
    body: JSON.stringify({
      input: { oldPassword, newPassword },
    }),
  });

  const responseData = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(responseData?.message || `Request failed with status ${response.status}`);
  }

  return responseData;
};
